import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const chartsRouter: RouteConfig = {
  path: '/visit',
  component: Layout,
  redirect: '/visit/list',
  meta: {
    title: 'visit',
    icon: 'el-icon-visits',
    privileges: ['VIEW_VISITS']
  },
  children: [
    {
      path: 'create',
      component: () => import(/* webpackChunkName: "visit-create" */ '@/views/visit/create.vue'),
      meta: {
        title: 'createVisit',
        icon: 'el-icon',
        privileges: ['CREATE_VISITS']
      }
    },
    {
      path: 'edit/:id',
      component: () => import(/* webpackChunkName: "visit-edit" */ '@/views/visit/edit.vue'),
      name: 'EditVisit',
      meta: {
        title: 'editVisit',
        icon: 'el-icon',
        noCache: true,
        activeMenu: '/visit/list',
        hidden: true,
        privileges: ['EDIT_VISITS', 'READ_VISITS']
      }
    },
    {
      path: 'list',
      component: () => import(/* webpackChunkName: "visit-list" */ '@/views/visit/list.vue'),
      meta: {
        title: 'visitList',
        icon: 'el-icon',
        privileges: ['LIST_VISITS']
      }
    }
  ]
}

export default chartsRouter
